import React from 'react';
import WidgetsSharpIcon from '@material-ui/icons/WidgetsSharp';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    display: 'inline-grid',
    justifyContent: 'center',
    alignContent: 'center',
    textAlign: 'center',
    background: '#0000008c',
  },
  font: {
    fontSize: 60,
    background: '#DFDFDF',
    width: 100,
    height: 100,
    padding: 15,
    borderRadius: '50%',
  },
  text: {
    color: '#fff',
    fontSize: '25px',
  },
}));

const FeatureCommoingSoon = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <WidgetsSharpIcon htmlColor="#fff" className={classes.font} />
      </div>
      <br />
      <Typography className={classes.text}>Feature Coming Soon</Typography>
    </div>
  )
}

export default FeatureCommoingSoon
